import { useState } from "react";


export const Contact = () => {

        const [paceRange, setPaceRange] = useState("");
        const [bestCaseTime, setBestCaseTime] = useState("");
        const [averageCaseTime, setAverageCaseTime] = useState("");
        const [worstCaseTime, setWorstCaseTime] = useState("");

    const handleSubmit = (e) => {
        e.preventDefault();
    
        const event = parseFloat(e.target.event.value); // Distance in miles
        const pace = e.target.elements.pace.value; // Pace in MM:SS format (minutes per mile)
    
        // Validate inputs
        if (!pace || !event || isNaN(event)) {
            console.error("Invalid input values. Please check the form inputs.");
            return;
        }
    
        const [minutes, seconds] = pace.split(':').map(Number);
        if (isNaN(minutes) || isNaN(seconds)) {
            console.error("Invalid pace format. Ensure it's in MM:SS format.");
            return;
        }
    
        const calculateMarathonTime = (pacePerMile) => {
            const [minutes, seconds] = pacePerMile.split(':').map(Number);
            const paceInSeconds = minutes * 60 + seconds;
    
            const marathonDistance = Number(event); // Distance in miles
            const totalTimeInSeconds = paceInSeconds * marathonDistance;
    
            // Convert total time to hours, minutes, and seconds
            const hours = Math.floor(totalTimeInSeconds / 3600);
            const remainingSeconds = totalTimeInSeconds % 3600;
            const minutesFormatted = Math.floor(remainingSeconds / 60);
            const secondsFormatted = Math.round(remainingSeconds % 60);
    
            return `${hours}:${minutesFormatted.toString().padStart(2, '0')}:${secondsFormatted.toString().padStart(2, '0')}`;
        };
    
        const calculateMarathonTimeRange = (averagePace, paceRange) => {
            const [avgMinutes, avgSeconds] = averagePace.split(':').map(Number);
            const avgPaceInSeconds = avgMinutes * 60 + avgSeconds;
    
            const minPaceInSeconds = avgPaceInSeconds - paceRange;
            const maxPaceInSeconds = avgPaceInSeconds + paceRange;
    
            const formatPace = (seconds) => {
                const minutes = Math.floor(seconds / 60);
                const secs = Math.round(seconds % 60);
                return `${minutes}:${secs.toString().padStart(2, '0')}`;
            };
    
            const minPace = formatPace(minPaceInSeconds);
            const maxPace = formatPace(maxPaceInSeconds);
    
            return {
                bestCaseTime: calculateMarathonTime(minPace),
                averageCaseTime: calculateMarathonTime(averagePace),
                worstCaseTime: calculateMarathonTime(maxPace),
                paceRange: `${minPace} to ${maxPace} per mile`,
            };
        };
    
        const averagePace = pace; // Pace in MM:SS per mile
        const paceRange = 45; // ±30 seconds variation in pace
        const marathonTimeRange = calculateMarathonTimeRange(averagePace, paceRange);
    
        setPaceRange(`Pace Range: ${marathonTimeRange.paceRange}`);
        setBestCaseTime(`Best-Case Finishing Time: ${marathonTimeRange.bestCaseTime}`);
        setAverageCaseTime(`Average-Case Finishing Time: ${marathonTimeRange.averageCaseTime}`);
        setWorstCaseTime(`Worst-Case Finishing Time: ${marathonTimeRange.worstCaseTime}`);
    };

    const handleReset = (e) => {
        
        e.preventDefault();
        const form = document.querySelector('form');
        form.reset(); 
    }   
    
  return (
    <>
    <h1 className="text-center text-4xl mb-6">Race Day Predition</h1>    
<form onSubmit={handleSubmit}>
    <div className="grid gap-6 mb-6 md:grid-cols-2">

    
    <div className="flex justify-start items-center">
       
    <div className="mx-4">
    <label htmlFor="event" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Choose Event</label>
        <select name="event" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" required>
            <option value="3.1">5k</option>
            <option value="6.1">10k</option>
            <option value="13.1">Half Marathon</option>
            <option value="26.2">Marathon</option>
            <option value="31.5">50k</option>
            <option value="52">52 Miles</option>
            <option value="62">100k</option>
            <option value="100">100 Mile</option>

        </select>
    </div>
       
       
        <div className="mx-4">
            <label htmlFor="pace" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Pace Per Mile</label>
            <input type="text" id="pace" name="pace" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="Pace Per Mile" required />
        </div>

     

    </div>

        <div className="flex justify-start items-center">


            

        </div>

        <h2 className="text-center m-4 text-lg">{paceRange}</h2>
        <h2 className="text-center m-4 text-lg">{bestCaseTime}</h2>
        <h2 className="text-center m-4 text-lg">{averageCaseTime}</h2>
        <h2 className="text-center m-4 text-lg">{worstCaseTime}</h2>

    </div>
    <button type="submit" className="m-4 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">Submit</button>


    <button onClick={handleReset} className=" m-4 text-white bg-green-700 hover:bg-green-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">Clear</button>
</form>

    </>
  )
}
